import React from 'react';
import DimensionCombination from '../DimensionCombination';
import { useQueryClient } from 'react-query';
import {
  AllDimensionList,
  PointerIconRing,
  ListWrapper,
  dimensionCustomCss,
} from '../styled';
import DimensionGroup from '../DimensionGroup';
import { CONFIG_LIST_KEY } from '@components/metrics-panel-hz/hooks/alerts/alertsQueryKey.constants';

export default function AIDimensions() {
  const queryClient = useQueryClient();
  const { aiAlertsConfig = [], customerRootCauseType = null } = queryClient.getQueryData(CONFIG_LIST_KEY) ?? {
    aiAlertsConfig: [], customerRootCauseType: null
  };
  const levelZeroComb = aiAlertsConfig[0]?.dimensionData;

  return (
    <AllDimensionList>
      <ListWrapper>
        <PointerIconRing margin="20px 18px 20px 11px" />
        <DimensionCombination customCss={dimensionCustomCss} combinations={levelZeroComb} level={0} />
      </ListWrapper>
      <DimensionGroup aiConfigList={aiAlertsConfig} customerType={customerRootCauseType} />
    </AllDimensionList>
  );
}
